var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHandWavingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9989 13.3022L11.7489 7.673C11.4181 7.09883 11.3287 6.41678 11.5005 5.77675C11.6723 5.13673 12.0911 4.59109 12.665 4.25975C13.2389 3.92841 13.9209 3.83848 14.5611 4.00973C15.2013 4.18097 15.7472 4.59938 16.0791 5.173L21.0791 13.8333",
    stroke: "#2C2E2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.169 16.6684L6.41899 8.4412C6.25451 8.15687 6.14768 7.84291 6.1046 7.51726C6.06152 7.19162 6.08304 6.86068 6.16792 6.54335C6.25281 6.22603 6.39939 5.92855 6.59931 5.6679C6.79922 5.40726 7.04853 5.18857 7.33301 5.02433C7.61748 4.86009 7.93153 4.75352 8.25721 4.71071C8.58289 4.6679 8.91381 4.6897 9.23106 4.77485C9.54832 4.86 9.84568 5.00683 10.1062 5.20696C10.3666 5.40709 10.5851 5.65659 10.7491 5.9412L14.9991 13.3024",
    stroke: "#2C2E2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.249 20.6635C18.586 19.5151 18.4063 18.1503 18.7495 16.8694C19.0928 15.5885 19.9307 14.4964 21.0792 13.8334L19.8292 11.6683C19.6647 11.384 19.5579 11.07 19.5148 10.7444C19.4717 10.4187 19.4932 10.0878 19.5781 9.77047C19.663 9.45314 19.8096 9.15566 20.0095 8.89502C20.2094 8.63437 20.4587 8.41568 20.7432 8.25144C21.0277 8.0872 21.3417 7.98063 21.6674 7.93782C21.9931 7.89502 22.324 7.91681 22.6412 8.00196C22.9585 8.08711 23.2559 8.23395 23.5163 8.43408C23.7768 8.63421 23.9953 8.8837 24.1593 9.16831L26.6593 13.4984C27.3162 14.6357 27.7427 15.8913 27.9144 17.1935C28.086 18.4956 27.9995 19.8188 27.6597 21.0875C27.3199 22.3562 26.7335 23.5455 25.934 24.5875C25.1345 25.6296 24.1376 26.5039 23.0002 27.1606C21.8627 27.8173 20.607 28.2435 19.3049 28.4149C18.0027 28.5863 16.6795 28.4994 15.4109 28.1593C14.1423 27.8193 12.9531 27.2326 11.9112 26.4329C10.8693 25.6332 9.99523 24.636 9.33878 23.4984L4.08878 14.4052C3.75792 13.831 3.66856 13.149 3.84035 12.5089C4.01213 11.8689 4.43099 11.3233 5.00489 10.9919C5.57879 10.6606 6.26076 10.5707 6.90093 10.7419C7.5411 10.9131 8.08709 11.3316 8.41891 11.9052L11.1689 16.6683",
    stroke: "#2C2E2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1368 30.0005C8.44183 28.8245 7.02895 27.2871 6 25.499",
    stroke: "#2C2E2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22 3.875C23.141 3.87485 24.2618 4.17519 25.2498 4.74581C26.2379 5.31643 27.0582 6.1372 27.6282 7.12554",
    stroke: "#2C2E2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandWavingIcon);
export default __webpack_public_path__ + "static/media/hand-waving-icon.9045f6daa933b7f9e65c048111016604.svg";
export { ForwardRef as ReactComponent };